import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import LangProvider from "./LanguageProvider";
import { CustomThemeProvider } from "./services/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CustomThemeProvider>
        <LangProvider>
          <App />
        </LangProvider>
      </CustomThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
